import React, { Component } from 'react';

import Footer from "../components/Footer"
import Modal from "../components/Modal";
import { __ } from "../Translator";
import Store from "../flux/Store";
import Actions from "../flux/Actions";
import InlineSvg from "./../InlineSvg";

import './Homepage.css';
import customWorksLogo from './../img/custom-works-logo.svg';
import AppActions from "../flux/AppActions";
import Dropdown from '../components/Dropdown';
import CountriesStore from '../flux/CountriesStore';
import CountryStore from '../flux/CountryStore';

class Homepage extends Component {
  ERROR_CONFIGURATION_HASH_CAN_NOT_BE_EMPTY = __('Please provide a configuration code.');
  ERROR_CONFIGURATION_NOT_FOUND = __('Configuration not found, or it is only personalized in Fit.');


  subscriptions = [];

  constructor(props) {
    super(props);

    this.state = {
      countries: CountriesStore.getState(),
      country: CountryStore.getState(),
      isModalVisible: false,
      hash: null,
      hasError: false,
      errorMessage: null,
    };

    this.onProductLoadByHash = this.onProductLoadByHash.bind(this);
    this.onCustomProductChange = this.onCustomProductChange.bind(this);
    this.onCountriesChange = this.onCountriesChange.bind(this);
    this.onCountryChange = this.onCountryChange.bind(this);
    this.handleCountryChange = this.handleCountryChange.bind(this);
  }

  componentDidMount() {
    Store.events.getProductByHash.addListener(this.onProductLoadByHash);
    Store.events.getCustomProduct.addListener(this.onCustomProductChange);

    this.subscriptions.push(CountryStore.addListener(this.onCountryChange));
    this.subscriptions.push(CountriesStore.addListener(this.onCountriesChange));

    AppActions.getCountries();
  }

  componentWillUnmount() {
    Store.events.getProductByHash.removeListener(this.onProductLoadByHash);
    Store.events.getCustomProduct.removeListener(this.onCustomProductChange);

    this.subscriptions.forEach(subscription => subscription.remove());
  }

  onProductLoadByHash(productCode, productPresetName, customProductHash, error) {
    if (error) {
      this.setState({ hasError: true, errorMessage: this.ERROR_CONFIGURATION_NOT_FOUND });
      AppActions.hideLoadingScreenOverlay();
    } else {
      this.setState({
        isModalVisible: false,
        hasError: false,
        errorMessage: null,
      });

      const product = Store.getProduct(productCode);
      const customProduct = Store.getCustomProduct(customProductHash);

      AppActions.initCustomProduct(product, customProduct);
      AppActions.setProductCategory(product.category);
      AppActions.loadProductInViewer(null);

      this.props.navigation.navigate('configurator');
    }
  }

  onLoadCustomProductClick() {
    if ( ! this.state.hash) {
      this.setState({ hasError: true, errorMessage: this.ERROR_CONFIGURATION_HASH_CAN_NOT_BE_EMPTY });
      return;
    }

    this.setState({ hasError: false, errorMessage: null });

    AppActions.showLoadingScreenOverlay(__('Looking for customization…'));
    Actions.getProductByHash(this.state.hash.toUpperCase());
  }

  onCustomProductChange() {
    AppActions.showLoadingScreenOverlay(__('Loading customization…'));
  }

  onCountryChange() {
    this.setState({ country: CountryStore.getState() });
  }

  onCountriesChange() {
    this.setState({ countries: CountriesStore.getState() });
  }

  handleCountryChange(country) {
    AppActions.updateCountry(country);
  }

  render() {
    const countries = this.state.countries
      .map(country => ({ value: country.id, text: __(country.name), online_purchase: country.online_purchase  }))
      .sort((a, b) => {
        if (a.text < b.text) return -1;
        if (a.text > b.text) return 1;
        return 0;
      });

    return (
      <div className="homepage">
          <InlineSvg className="logo" svg={customWorksLogo} />

          <div  className="home__country" style={{ marginBottom: '4.5rem',zIndex: 2, textAlign:'left' }}>
            <Dropdown
              defaultText={this.state.countries.length ? __('Select your country to begin...') : __('Loading countries...')}
              selected={this.state.country || ''}
              options={countries}
              onChange={this.handleCountryChange}
            />
          </div>

          <div className="u-ta-center">
            <button className="startTheExperience btn btn-primary" onClick={() => {
              Actions.getProducts();
              this.props.navigation.navigate('productSelection');
            }} disabled={this.state.country === null}>
              {__('Start the experience')}
            </button>
          </div>

          <div className="u-ta-center u-mt-40 ">
            <button className="loadCustomProduct muted" onClick={() => {
              this.setState({ isModalVisible: true });
            }}>
              {__('Retrieve previous configuration')}
            </button>
        </div>

        <Modal
          className="loadCustomProductModal"
          visible={this.state.isModalVisible}
          noFooterPadding={true}
          onCloseClick={() => {
            // @todo 2017-09-15 Stop load suit
          }}
          actions={
            <div className="text-center">
              <button className="btn btn-primary" onClick={() => this.onLoadCustomProductClick()}>
                {__('Enter')}
              </button>
            </div>
          }
        >
          <div>
            <h1 className="u-tt-uppercase u-pb-60">{__('Insert the code to retrieve your previous configuration')}</h1>
            <div className={`form-group ${this.state.hasError ? 'has-error' : ''}`}>
              <input type="text"
                     className="form-control"
                     onChange={e => this.setState({ hash: e.target.value, hasError: false, errorMessage: null }) }
              />
              <p className={`help-block text-left u-mb-0 ${this.state.hasError ? 'visible' : 'invisible'}`}>
                {this.state.errorMessage}&nbsp;
              </p>
            </div>
          </div>
        </Modal>
        <Footer
          showBackButton={false}
          showNextButton={false}
          showPrice={false}
        />
      </div>
    );
  }
}

Homepage.defaultProps = {
  onCustomProductHashSubmission: console.log,
};

export default Homepage;



// WEBPACK FOOTER //
// ./src/screens/Homepage.js